import SidePanelHeader from "../components/SidePanelHeader"
import { useNavigate } from "react-router"
import * as Navigation from "../../../../../modules/Navigation";
import SidePanelInfo from "../components/SidePanelInfo"
import { SingularUpperCase } from "../../../../../helpers/EntityNameHelper"
import SidePanelBreadCrumb from "../components/SidePanelBreadCrumb";


export default function SidePanelCaseMaterials({ data, onViewPage }: any) {
    const navigate = useNavigate()
    function viewEntity() {
        Navigation.view.navigate(navigate, data.entityName, data.id, data)
    }

    return (<>
        {data &&
            <>
                {!onViewPage && <SidePanelHeader descriptor="Collection of" value={`${SingularUpperCase(data.type)}`} statuses={data.status} onClick={(() => { viewEntity() })} />}
                <SidePanelInfo
                    values={[
                        { label: "Year", value: data.year },
                        { label: "Account", value: data.accountName },
                        { label: "Type", value: data.type },
                        { label: "Quantity", value: data.quantity },
                    ]}
                />
                <SidePanelBreadCrumb descriptor="Current location" value={data.currentLocation} />
            </>
        }
    </>)
}